import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { Dossier } from '@sc/data-access-models';
import {
  ReplaceDossiersRequestedAppointmentAction,
  SetDossiersRequestedAppointmentAction,
  SetNewDossierRequestedAppointmentAction,
} from './dossiers-requested-appointment.actions';

export const DossiersRequestedAppointmentStateKey: Readonly<string> =
  'dossiersRequestedAppointment';
export const DossiersRequestedAppointmentStateDefault: Dossier[] = [];

@State<Dossier[]>({
  name: DossiersRequestedAppointmentStateKey,
  defaults: DossiersRequestedAppointmentStateDefault,
})
@Injectable()
export class DossiersRequestedAppointmentState {
  @Action(SetDossiersRequestedAppointmentAction)
  setDossiers(
    ctx: StateContext<Dossier[]>,
    { payload }: SetDossiersRequestedAppointmentAction
  ): void {
    ctx.setState(payload);
  }

  @Action(SetNewDossierRequestedAppointmentAction)
  setNewDossier(
    ctx: StateContext<Dossier[]>,
    { payload }: SetNewDossierRequestedAppointmentAction
  ): void {
    const state = ctx.getState() ? [...ctx.getState()] : [];

    state.push(payload);

    ctx.setState(state);
  }

  @Action(ReplaceDossiersRequestedAppointmentAction)
  replaceDossiers(
    ctx: StateContext<Dossier[]>,
    { payload }: ReplaceDossiersRequestedAppointmentAction
  ): void {
    let state = ctx.getState() ? [...ctx.getState()] : [];

    state = state.filter(
      (stateDossier) =>
        payload.findIndex(
          (payloadDossier) => payloadDossier.id === stateDossier.id
        ) === -1
    );

    state.push(...payload);

    ctx.setState(state);
  }
}
